export const getChunks = (arr, chunkSize) => {
  const res = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    const chunk = arr.slice(i, i + chunkSize);
    res.push(chunk);
  }

  const chunkObject = {};
  res.forEach(
    (chunk, index) => (chunkObject[index] = { loaded: false, ids: chunk })
  );

  return chunkObject;
};
